import React, {useState, useRef} from "react";
import {
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
  MenuItem,
  MenuList,
} from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

interface MaterialiseSplitButtonProps {
  onMaterialise: (withLatestDependencies: boolean) => void;
  disabled?: boolean;
  warningMessage?: string;
}

export const MaterialiseSplitButton: React.FC<MaterialiseSplitButtonProps> = ({
  onMaterialise,
  disabled = false,
  warningMessage,
}) => {
  const [splitButtonOpen, setSplitButtonOpen] = useState(false);
  const splitButtonRef = useRef<HTMLDivElement>(null);

  const handleSplitButtonClick = () => {
    setSplitButtonOpen(prevOpen => !prevOpen);
  };

  const handleSplitButtonClose = (event: React.MouseEvent<Document>) => {
    if (
      splitButtonRef.current &&
      splitButtonRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }
    setSplitButtonOpen(false);
  };

  const handleMenuItemClick = (withLatestDependencies: boolean) => {
    onMaterialise(withLatestDependencies);
    setSplitButtonOpen(false);
  };

  return (
    <div ref={splitButtonRef}>
      <ButtonGroup variant="contained" color="primary" disabled={disabled}>
        <Button
          onClick={() => onMaterialise(false)}
          endIcon={warningMessage && <WarningIcon />}
        >
          Materialise
        </Button>
        <Button size="small" onClick={handleSplitButtonClick}>
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        open={splitButtonOpen}
        anchorEl={splitButtonRef.current}
        role={undefined}
        transition
        disablePortal
        placement="bottom-end"
      >
        {({TransitionProps, placement}) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleSplitButtonClose}>
                <MenuList>
                  <MenuItem onClick={() => handleMenuItemClick(false)}>
                    Materialise
                  </MenuItem>
                  <MenuItem onClick={() => handleMenuItemClick(true)}>
                    Materialise with latest dependencies
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
};
